// extracted by mini-css-extract-plugin
export default {"canvas":"NGpL2GI0qPp8bhO9wJJA"};